import { CaretDown } from '@phosphor-icons/react';
import { vars } from '@etg/wings';
import { cardTitle, toggleIconStyles } from './styles';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const AvailabilityHeader = props => {
  var _productData$extraPro;
  const {
    isOpen,
    isSelected,
    onClick,
    productData
  } = props;
  const {
    availabilityTitle,
    addedTitle
  } = (_productData$extraPro = productData.extraProps) === null || _productData$extraPro === void 0 || (_productData$extraPro = _productData$extraPro.availabilityTranslation) === null || _productData$extraPro === void 0 ? void 0 : _productData$extraPro.availabilityCard;
  return /*#__PURE__*/_jsxs("button", {
    className: cardTitle(isSelected),
    "data-testid": "toggle-availability-button",
    disabled: !isSelected,
    onClick: onClick,
    role: isSelected ? 'button' : 'presentation',
    type: "button",
    children: [isSelected ? addedTitle : availabilityTitle, isSelected && /*#__PURE__*/_jsx(CaretDown, {
      className: toggleIconStyles(isOpen),
      color: vars.colors.text.primary,
      "data-testid": "availabilityArrowIcon",
      size: 24,
      weight: "light"
    })]
  });
};
export default AvailabilityHeader;
//# sourceMappingURL=AvailabilityHeader.js.map